import logger from "@next/core-logger"
import {AxiosRequestConfig} from "axios"
import {IncomingHttpHeaders} from "http"
import axios from "../../utils/axios"
import ProductsApi from "../../config/api/products"
import {SearchApiRequestTypes, TOKEN_CANCELLATION_FLAG} from "../../config/constants"
import {ExternalSearchApiResponse, pageLoadTriggerType} from "../../models/searchApi"
import {BloomreachCookiesInitialVal} from "../../models/SearchState"
import {httpUrlTrimmer, urlSanitiser} from "../../utils/httpUrlTrimmer"
import {devboxUrlTrimmer} from "../../utils/devboxUrlTrimmer"
import buildProductsRequestParams from "../../utils/buildProductsRequestParams"

interface GetSearchResultsFnOptions {
    headers: IncomingHttpHeaders
    url: string
    baseUrl: string
    searchTerm: string | null
    type: SearchApiRequestTypes
    start: number
    pageSize: number
    fields: (keyof ExternalSearchApiResponse)[]
    bloomreachCookiesInitialVal: BloomreachCookiesInitialVal
    bloomreachPersonalizationEnabled: boolean
    cancelToken?: AxiosRequestConfig["cancelToken"]
    pageLoadTrigger: pageLoadTriggerType
    sliceSize: number
    apiProxyVersion: string
    bloomreachDefaultProviderArgs: string
}

export const getSearchResults = async ({
    url,
    baseUrl,
    headers,
    searchTerm,
    type,
    start,
    pageSize,
    fields,
    bloomreachCookiesInitialVal,
    bloomreachPersonalizationEnabled,
    cancelToken,
    pageLoadTrigger,
    sliceSize,
    apiProxyVersion,
    bloomreachDefaultProviderArgs,
}: GetSearchResultsFnOptions): Promise<string> => {
    try {
        const getSearchResultsApi = ProductsApi("getSearchResults")

        const urlParam = devboxUrlTrimmer(httpUrlTrimmer(url))

        const response = await axios({
            method: getSearchResultsApi.method,
            url: `${urlSanitiser(baseUrl)}${getSearchResultsApi.localEndpoint(apiProxyVersion)}`,
            headers: headers as {
                [header: string]: string
            },
            params: buildProductsRequestParams({
                url: urlParam,
                searchTerm,
                type,
                pageSize,
                bloomreachCookiesInitialVal,
                bloomreachPersonalizationEnabled,
                pageLoadTrigger,
                sliceSize,
                fields,
                start,
                bloomreachDefaultProviderArgs,
            }),

            cancelToken,
        })
        return response.data as string
    } catch (error) {
        const err = error as Error

        if (err.message !== TOKEN_CANCELLATION_FLAG) {
            logger.error(error, "getProductFragments")
        }

        throw error
    }
}
